import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {ApiService} from '../../services/api.service';
import {SessionService} from '../../services/session.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  language = localStorage.getItem('lang') || 'en';
  username = '';
  toggleNav: boolean;
  enabledCustomerRequest = environment.enabledCustomerRequest;

  constructor(
    private authService: AuthenticationService,
    private sessionService: SessionService,
    private translate: TranslateService,
    private router: Router,
    private apiService: ApiService
  ) {
    this.language = translate.currentLang;
  }

  ngOnInit() {
    const username = localStorage.getItem('username');
    this.username = username;
    this.toggleNav = true;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  canUserSignDoc() {
    return this.authService.isAccountant();
  }

  changeLanguage() {
    this.translate.use(this.language);
    localStorage.setItem('lang', this.language);
    this.sniff('CHANGE_LANG', this.language);
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

  isUIH() {
    return this.authService.isUIH();
  }

  isAccountant() {
    return this.authService.isAccountant();
  }

  isAccountantAdmin() {
    return this.authService.isAccountantAdmin();
  }

  isIT() {
    return this.authService.isIT();
  }
  
  isOperation() {
    return this.authService.isOperation();
  }

  getUsername() {
      return localStorage.getItem('username');
  }

  getRole() {
      return localStorage.getItem('group');
  }

  logout() {
      this.apiService.logout().subscribe(() => {
        this.router.navigate(['/login']);
        this.sessionService.stop();
      });
      this.sniff('LOGOUT', this.username);
  }

  get requireToChangePassword(): boolean {
      return localStorage.getItem('require_to_change_password') === 'true';
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'HOME',
      target: target
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/core/navbar/navbar.component.ts